// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderPrice":"c-m_fo","advertDetailHeaderPrice__value":"c-m_fp","advertDetailHeaderPrice__label":"c-m_fq"};